import {v4 as uuidv4} from "uuid";
import {getDownloadURL, ref, uploadBytes} from "firebase/storage";
import {storage} from "../firebaseConfig";
import React from "react";

export const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, setter: React.Dispatch<React.SetStateAction<File | null>>) => {
  if (event.target.files && event.target.files[0]) {
    setter(event.target.files[0]);
  }
};

export const uploadFile = async (file: File, folder: string) => {
  const timestamp = new Date().getTime(); // Get timestamp
  const uniqueFileName = `${timestamp}-${uuidv4()}-${file.name}`; // Add timestamp and UUID
  const fileRef = ref(storage, `${folder}/${uniqueFileName}`); // Store in specific folder
  try {
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef); // Get file URL after upload
  } catch (error) {
    console.error("Upload failed:", error);
    return null;
  }
};
